import { essentialFormApiConnector } from 'apiConnector/form/essential';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import type { FunkyAction } from 'shared/middlewares/epic/epicMiddleware.factory';
import { essentialReloadFormFromQuoteFailedThunk, essentialReloadFormFromQuoteThunk } from 'state/essential/thunks';
import { isUserPreferencesPrivateMode } from 'state/selectors';
import type { EpicWithThunk } from 'state/state.common';

export function reloadQuoteEpic(): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('WORKSPACE_QUOTE_RELOAD_REQUESTED'),
      filter(action => action.workspace === 'essential'),
      withLatestFrom(state$),
      mergeMap(([{ temporaryFormId, identifier, idType, tradeDate }, state]) => {
        const isPrivateMode = isUserPreferencesPrivateMode(state);
        return essentialFormApiConnector(httpClient)
          .reloadForm({ id: identifier, idType, tradeDate, isPrivateMode, tabId: temporaryFormId })
          .pipe(
            map(
              ({
                fieldsMetadata,
                productView,
                blocksMetadata,
                values,
                version,
                negotiationId,
                actions,
                quoteQuery,
                errors,
                mustForceAdvancedMode,
                allowedRequests,
                sendWholeFormData,
                quoteId,
                productLayout,
              }) => {
                return essentialReloadFormFromQuoteThunk(
                  temporaryFormId,
                  quoteId ?? '',
                  productView,
                  negotiationId,
                  blocksMetadata,
                  fieldsMetadata,
                  values,
                  version,
                  actions,
                  quoteQuery,
                  mustForceAdvancedMode ?? false,
                  allowedRequests,
                  errors,
                  sendWholeFormData,
                  productLayout,
                );
              },
            ),
            catchError(() => {
              return of<FunkyAction>(essentialReloadFormFromQuoteFailedThunk(identifier));
            }),
          );
      }),
    );
}
